import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Tabs, Box } from '@mui/material';
import { useTokens } from '@mcn-platform/models';
import { StyledTab, TabPanel } from '../../common/CustomTab';
import About from '../../item/LandingPageTabs/aboutContent/AboutContent';
import Instructors from '../../item/LandingPageTabs/instructorsContent/InstructorsContent';
import SyllabusContent from '../../item/LandingPageTabs/syllabusContent/SyllabusContent';
// import Resources from 'portal/course/Tab/resourceContent/Resources';
import Reviews from '../../item/LandingPageTabs/reviewsContent/ReviewsContent';
import FAQs from '../../item/LandingPageTabs/faqContent/FAQContent';
function a11yProps(index) {
    return {
        id: `course-tab-${index}`,
        'aria-controls': `course-tabpanel-${index}`,
    };
}
const DetailTabs = ({ course, action, buttonLabel, showPrice, }) => {
    const [value, setValue] = React.useState(0);
    const tokens = useTokens();
    const tabs = [
        {
            label: 'About This Course',
            show: true,
            component: _jsx(About, { course: course, action: action, showPrice: showPrice, buttonLabel: buttonLabel }),
        },
        {
            label: tokens.getToken('instructorName/plural'), show: true, component: _jsx(Instructors, { instructors: course.instructors }),
        },
        {
            label: tokens.getToken('courseOutlineLabel'), show: true, component: _jsx(SyllabusContent, { item: course, sections: course.sections }),
        },
        {
            label: 'Reviews', show: true, component: _jsx(Reviews, { reviews: course.reviews }),
        },
        {
            label: 'FAQs', show: true, component: _jsx(FAQs, { faqs: course.faqs }),
        },
    ];
    return (_jsxs(Box, { sx: { width: '100%' }, children: [_jsx(Tabs, { value: value, onChange: (e, newValue) => setValue(newValue), "aria-label": "course-tabs", variant: "fullWidth", children: tabs.filter((tab) => tab.show).map((tab, index, allTabs) => (_jsx(StyledTab, { value: index, label: tab.label, ...a11yProps(index), sx: { mr: index < (allTabs.length - 1) ? 0.625 : 0 } }))) }), tabs.filter((tab) => tab.show).map((tab, index) => (_jsx(TabPanel, { isSelected: value === index, index: index, firstTab: index === 0, lastTab: index === tabs.length - 1, children: tab.component })))] }));
};
export default observer(DetailTabs);
//# sourceMappingURL=Tab.js.map